import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined"
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined"
import Chip from "@mui/material/Chip"
import Fade from "@mui/material/Fade"
import IconButton from "@mui/material/IconButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import { useState } from "react"

import Column from "../../../../../common/components/Column"
import Row from "../../../../../common/components/Row"
import { trimLongString } from "../../../../../common/utils"
import DeleteTileWarningDialog from "../DeleteTileWarningDialog"

export default function BaseNode({
  node,
  children,
  rootProps,
  Container = NodeContainer,
}) {
  const [hovered, setHovered] = useState(false)
  const [isDeleteTileDialogOpen, setIsDeleteTileDialogOpen] = useState(false)
  const [menuAnchor, setMenuAnchor] = useState(null)

  function handleDeleteTileMenuItemClicked(e) {
    e.stopPropagation()
    closeMenu()
    setIsDeleteTileDialogOpen(true)
  }

  function closeMenu() {
    setMenuAnchor(null)
  }

  return (
    <Container
      elevation={0}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Column {...rootProps}>{children}</Column>
      <Fade in={hovered}>
        <IconButton
          size="small"
          sx={{ position: "absolute", top: "8px", right: "8px" }}
          onClick={(e) => setMenuAnchor(e.currentTarget)}
        >
          <MoreVertOutlinedIcon fontSize="small" varaint="g400" />
        </IconButton>
      </Fade>
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={closeMenu}
        anchorOrigin={{
          horizontal: "center",
          vertical: "bottom",
        }}
        transformOrigin={{
          horizontal: "left",
          vertical: "top",
        }}
      >
        <MenuItem onClick={handleDeleteTileMenuItemClicked}>
          <ListItemIcon>
            <DeleteOutlinedIcon />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>
      <DeleteTileWarningDialog
        open={isDeleteTileDialogOpen}
        onClose={() => setIsDeleteTileDialogOpen(false)}
        node={node}
      />
    </Container>
  )
}

export function NodeContentLayout({ Icon, title, subtitle, children }) {
  return (
    <Column sx={{ p: 1 }}>
      <Row>
        <Icon sx={{ width: "16px" }} />
        <Column sx={{ ml: 1.5 }}>
          <Typography
            variant="h6"
            title={title}
            sx={{ lineHeight: 1.2, fontWeight: 600 }}
          >
            {trimLongString(title, 15)}
          </Typography>
          <Typography
            variant="subtitle2"
            color="text.secondary"
            sx={{ fontSize: "12px" }}
          >
            {trimLongString(subtitle, 21)}
          </Typography>
        </Column>
      </Row>
      <Column sx={{ mt: 1 }}>{children}</Column>
    </Column>
  )
}

export const NoPaddingNodeContainer = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "265px",
  backgroundColor: "white",
  position: "relative",
  cursor: "pointer",
}))

export const NodeContainer = styled(NoPaddingNodeContainer)(({ theme }) => ({
  padding: theme.spacing(1),
  paddingTop: theme.spacing(2),
}))

export const PurpleNodeLabel = styled(Chip)(({ theme }) => ({
  border: `1px solid ${theme.palette.colors.brand200}`,
  borderRadius: "12px",
  color: theme.palette.colors.brand700,
  backgroundColor: theme.palette.colors.brand50,
  fontSize: "10px",
  fontWeight: 600,
  position: "absolute",
  height: "17px",
  top: -10,
  left: "40%",
  "& .MuiChip-label": {
    paddingInline: "6px",
  },
}))

export const GreenNodeLabel = styled(PurpleNodeLabel)(({ theme }) => ({
  borderColor: theme.palette.colors.success200,
  color: theme.palette.colors.success700,
  backgroundColor: theme.palette.colors.success50,
  left: "41%",
}))
